import styled from 'styled-components';

interface PietroskInputProps {
    darkMode?: boolean;
    width?: string;
    heigth?: string;
    margin?: string;
    textPadding?: string;
}

export const PietroskiInput = styled.input`
    align-self: center;
    width: ${(props: PietroskInputProps) => props.width ? `${props.width}` : "100%"};
    height: ${(props: PietroskInputProps) => props.heigth ? `${props.heigth}` : "30px"};
    border-radius: 5px;
    border: 0.5px solid black;
    margin: ${(props: PietroskInputProps) => props.margin ? `${props.margin}` : "0"};
    background-color: ${(props: PietroskInputProps) => props.darkMode ? "#545454" : "rgb(205,205,205)"};
    padding-left: ${(props: PietroskInputProps) => props.textPadding ? `${props.textPadding}` : "0.2rem"};
    color: ${(props: PietroskInputProps) => props.darkMode ? "whitesmoke" : "black"};
`;